import styles from "./style.module.scss"

function HeaderTitle({ text }: { text: string }) {
  return <p className={styles.headerTitle || styles.header}>{text}</p>
}

export default HeaderTitle
